import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "../data";

export const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="bg-obsidian text-bone">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-6">
            <h3 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9]">
              Let's clear<br />the way.<span className="text-terra">.</span>
            </h3>
            <button
              data-testid="footer-quote-btn"
              onClick={() => go("quote")}
              className="btn-wipe mt-8 inline-flex bg-terra text-bone font-bold px-8 py-4 tracking-tight"
            >
              Request a Quote
            </button>
          </div>
          <div className="md:col-span-3">
            <span className="text-xs uppercase tracking-[0.25em] text-bone/50">Contact</span>
            <div className="mt-5 space-y-4 text-sm">
              <a href={CONTACT.phoneHref} className="flex items-center gap-3 hover:text-terra transition-colors"><Phone size={16} className="text-terra" /> {CONTACT.phone}</a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-terra transition-colors break-all"><Mail size={16} className="text-terra" /> {CONTACT.email}</a>
              <p className="flex items-start gap-3 text-bone/70"><MapPin size={16} className="text-terra mt-0.5 shrink-0" /> {CONTACT.areas}</p>
            </div>
          </div>
          <div className="md:col-span-3">
            <span className="text-xs uppercase tracking-[0.25em] text-bone/50">Explore</span>
            <div className="mt-5 flex flex-col gap-3 text-sm">
              {["services", "approach", "work", "reviews", "quote"].map((id) => (
                <button key={id} onClick={() => go(id)} className="text-left capitalize text-bone/80 hover:text-terra transition-colors w-fit">{id}</button>
              ))}
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row md:items-center justify-between gap-5 text-xs text-bone/50">
          <img src="/logo.png" alt="Exterior Nature Care" className="h-16 md:h-20 w-auto" />
          <span>Owner-operated by {CONTACT.owner} · © {new Date().getFullYear()} · Hard work, honest service.</span>
        </div>
      </div>
    </footer>
  );
};
